module.exports = __webpack_public_path__ + "static/intro-mobile-00a0b10fdc7b3a03f82d21525f9d204c.svg";